<template>
  <div
    :style="{backgroundImage: `url(${require('@/assets/images/pages/login/login_main.svg')})`}"
    style="height: 100vh; background-repeat: no-repeat; background-size: 100% 100%;"
    class="d-flex justify-content-center align-items-center"
  >
    <b-card class="col-6">
      <validation-observer ref="client_form">
        <validation-provider
          #default="{ errors }"
          :name="$t('objects.client')"
          rules="required"
        >
          <label for="autosuggest__input">{{ $t('clients.phone_number') }}:</label>
          <vue-autosuggest
            v-model="client.phones[0]"
            :suggestions="suggestOptions"
            :input-props="{id:'autosuggest__input', class: 'form-control', placeholder: $t('generals.search') }"
            :limit="10"
            :get-suggestion-value="option => option.item.phones[0]"
            @selected="onSelected"
            @input="searchClients"
            @keyup="formatPhone"
          >
            <template slot-scope="{suggestion}">
              <div class="d-flex align-items-center">
                <div class="detail ml-50">
                  <b-card-text class="mb-0">
                    {{ suggestion.item.title }}
                  </b-card-text>
                  <b-card-text>
                    {{ suggestion.item.phones }}
                  </b-card-text>
                </div>
              </div>
            </template>
          </vue-autosuggest>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <validation-provider
          #default="{ errors }"
          name="Клиент"
          rules="required"
        >
          <b-form-group class="mt-2">
            <label for="phone__number">{{ $t('objects.client') }}:</label>
            <b-form-input
              v-model="client.title"
              :disabled="client_selected"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

      </validation-observer>
      <b-button
        class="ml-auto"
        variant="primary"
        @click="saveClick"
      >
        {{ $t('generals.save') }}
      </b-button>
    </b-card>
    <client-modal
      :client-info="client_info"
      @modalClosed="modalClose"
      @refresh="saveSuccess"
    />
  </div>
</template>

<script>
import {
  BCard, BButton, BFormInput, BFormGroup, BCardText,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { VueAutosuggest } from 'vue-autosuggest'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@validations'
import clientModal from './components/ClientModal.vue'

export default {
  components: {
    BCard,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BFormInput,
    BFormGroup,
    BCardText,
    VueAutosuggest,
    clientModal,
  },
  data() {
    return {
      required,
      phoneValue: '',
      client: {
        phones: [],
      },
      selected_client: {},
      client_selected: false,
      timeout: 600,
      client_title: '',
      client_modal: false,
      client_info: {},
    }
  },
  computed: {
    ...mapGetters('clients', ['getClientsList']),
    suggestOptions() {
      if (this.getClientsList.results.length && this.client_title) {
        return [{ data: this.getClientsList.results }]
      }
      return []
    },
  },
  methods: {
    ...mapActions('clients', ['FETCH_CLIENTS_LIST', 'ADD_NEW_CLIENT']),
    ...mapActions('kanban', ['ADD_NEW_LID']),
    onSelected(option) {
      this.client_selected = true
      this.selected_client = this.$_removeObjectConnection(option.item)
      console.log(this.selected_client)
      const [phone] = option.item.phones
      this.selected = phone
      // const [phone] = option.item.phones
      this.client = option.item
      // eslint-disable-next-line
      this.phoneValue = this.selected_client.phones[0]
      this.formatPhoneOnBlur()
      console.log(this.client)
    },
    searchClients(text) {
      this.client_selected = false
      // this.client = {
      //   phones: [],
      // }
      // this.client.title = text
      this.client_title = text
      clearTimeout(this.timeout)
      if (text) {
        this.timeout = setTimeout(() => {
          this.FETCH_CLIENTS_LIST({ search: text.replace(/-/g, '') })
        }, 600)
      }
    },
    saveClick() {
      if (this.client.phones[0].replace(/-/g, '').length < 9) {
        this.$refs.client_form.errors[this.$t('objects.client')].push(this.$t(''))
      } else if (this.client.phones[0].replace(/-/g, '').length >= 9) {
        // this.phoneValue = `998${this.client.phones[0]}`
        // this.client.phones[0] = this.phoneValue.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/g, '+$1-$2-$3-$4-$5')
        this.$refs.client_form.validate().then(success => {
          if (success) {
            if (this.client_selected) {
              sessionStorage.setItem('selected_client', JSON.stringify(this.client))
              this.$router.push({ name: 'clients-flat-choose' })
              // this.ADD_NEW_LID({ client: this.client.id }).then(() => {
              // })
            } else {
              // this.client.entity = 'fizichiskiy'
              // this.client.phones = [this.client.phones[0].replace(/[^0-9]+/gi, '')]
              this.client_info = {
                title: this.client.title,
                phones: [this.client.phones[0]],
                entity: 'fizichiskiy',
              }
              // this.client_modal = true
              this.$nextTick(() => {
                this.$bvModal.show('client-modal')
              })
              // this.ADD_NEW_CLIENT(this.client).then(resp => {
              //   this.$_successToast(this.$t('clients.added_new_client'))
              //   sessionStorage.setItem('selected_client', JSON.stringify(resp.data))
              //   this.$router.push({ name: 'clients-flat-choose' })
              //   // this.ADD_NEW_LID({ client: resp.data.id }).then(() => {
              //   // })
              // }).catch(() => {
              //   this.$_errorToast(this.$t('generals.error'))
              // })
            }
          }
        })
      }
    },
    formatPhoneOnBlur() {
      if (this.client.phones[0].replace(/-/g, '').length < 9 && !this.client_selected) {
        console.log('sbnkjs', this.client)
        setTimeout(() => {
          this.$refs.client_form.errors[this.$t('objects.client')].push(this.$t('clients.number_incorrect'))
        }, 200)
      } else if (this.client.phones[0].replace(/-/g, '').length === 9) {
        console.log('skjsskj')
        this.phoneValue = `998${this.client.phones[0]}`
        this.client.phones[0] = this.phoneValue.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/g, '+$1-$2-$3-$4-$5')
      } else {
        const [first] = this.client.phones[0].replace(/-/g, '').match(/(\d{1,12})/g)
        this.phoneValue = first
        this.client.phones[0] = first.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/g, '+$1-$2-$3-$4-$5')
      }
    },
    formatPhone(event) {
      if (['Arrow', 'Backspace', 'Shift'].includes(event.key)) {
        this.preventNextIteration = true
        return
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false
        return
      }
      if (this.client.phones[0].replace(/-/g, '').length === 9) {
        console.log('skjsskj')
        this.phoneValue = `998${this.client.phones[0].replace(/-/g, '')}`
      } else {
        const [first] = this.client.phones[0].replace(/-/g, '').match(/(\d{1,12})/g)
        this.phoneValue = first
      }

      // Format display value based on calculated currencyValue
      this.client.phones[0] = this.phoneValue.replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/g, '+$1-$2-$3-$4-$5')
    },
    modalClose() {
      this.formatPhoneOnBlur()
    },
    saveSuccess(resp) {
      this.$_successToast(this.$t('clients.added_new_client'))
      sessionStorage.setItem('selected_client', JSON.stringify(resp.data))
      this.$router.push({ name: 'clients-flat-choose' })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
